/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { ptBR } from 'date-fns/locale';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { AccessTime } from '@material-ui/icons';
import { v4 } from 'uuid';
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';

import './styles.scss';
import deleteHours from '../../../../assets/images/icon_delete.svg';
import addHours from '../../../../assets/images/adicionar_blue.svg';
import Select from '../../../Select';

const getDefaultSchedule = () => {
  return {
    from: moment(),
    to: moment().add(1, 'hour'),
    inputFrom: '',
    inputTo: '',
    _id: v4(),
  };
};

const getInitialBusiness = () => {
  const firstElement = {
    schedules: [getDefaultSchedule()],
    weekDays: [],
    _id: v4(),
  };
  return [firstElement];
};

const INITIAL_ESCAPE = {
  to: '',
  message: '',
  itemId: '',
};

const selectValue = [
  { value: 'message', label: 'Enviar mensagem automática' },
  { value: 'item', label: 'Direcionar para outro item' },
];

const SettingsAttendanceHours = (props) => {
  const { bot, user, companies, updateAttendanceHoursSettings } = props;

  const [viewer, setViewer] = useState(false);

  useEffect(() => {
    if (user?.selectedCompany?.claim?.name === 'Viewer') {
      setViewer(true);
    }
  }, []);

  const items = useSelector((state) => state.items.allItems || []);

  const [itemList, SetItemList] = useState([]);

  const getBotInitBusinessHours = () => {
    const { settings } = bot;
    if (
      Array.isArray(settings?.timezone?.businessHours) &&
      settings?.timezone?.businessHours?.length > 0
    ) {
      return settings.timezone.businessHours.map((businessHour) => {
        return {
          ...businessHour,
          schedules: businessHour?.schedules.map((schedule) => {
            return { ...schedule, inputFrom: '', inputTo: '' };
          }),
        };
      });
    }
    return getInitialBusiness();
  };

  const [AttendanceHoursSettings, setAttendanceHoursSettings] = useState({
    fusoName: bot?.settings?.timezone?.fusoName || '',
    fuso: bot?.settings?.timezone?.fuso || '',
    businessHours: getBotInitBusinessHours(),
    escape: bot.settings?.timezone?.escape || INITIAL_ESCAPE,
  });

  useEffect(() => {
    const item = items.map((e) => {
      return { value: e._id, label: `${e.title} ${e._id}` };
    });
    SetItemList(item);
  }, []);

  useEffect(() => {
    if (
      companies &&
      Array.isArray(companies) &&
      companies.length > 0 &&
      !bot?.settings?.timezone?.fusoName
    ) {
      const companyId = user.selectedCompany._id;
      const company = companies.find(({ _id }) => _id === companyId);

      if (company && company.timezone) {
        const { timezone } = company;
        const { fusoName, fuso } = timezone;
        const newAttendanceHoursSettings = {
          ...AttendanceHoursSettings,
          fusoName,
          fuso,
        };
        setAttendanceHoursSettings(newAttendanceHoursSettings);
      }
    }
  }, [companies]);

  const handleFindItemSelected = () => {
    const { itemId } = AttendanceHoursSettings.escape;

    if (Array.isArray(itemId)) {
      const stagItemId = itemId.find(({ version }) => version === 0);
      return stagItemId?.id
        ? itemList.find((item) => item.value === stagItemId.id)
        : null;
    }

    return itemList.find((item) => item.value === itemId);
  };

  const handleFindEscapeSelected = () => {
    const { to: itemId } = AttendanceHoursSettings.escape;
    const findItem = selectValue.find((item) => item.value === itemId);

    return findItem;
  };

  const resultDelete = (sche, index, businessIndex) => {
    if (Array.isArray(sche) && sche?.length > 1) {
      return (
        <img
          className="img-action"
          src={deleteHours}
          onClick={() => removeSchedules(index, businessIndex)}
          alt=""
        />
      );
    }
  };

  const resultAdd = (sche, index, businessIndex) => {
    if (Array.isArray(sche) && index === sche?.length - 1 && sche?.length < 4) {
      return (
        <img
          className="img-action"
          src={addHours}
          onClick={() => createSchedules(businessIndex)}
          alt=""
        />
      );
    }
  };

  const resultHoursAttendance = (index) => {
    if (
      Array.isArray(AttendanceHoursSettings?.businessHours) &&
      index === 0 &&
      AttendanceHoursSettings.businessHours.length === 1
    ) {
      return (
        <div className="container-bussines-action">
          <span> Horário de Funcionamento: </span>
        </div>
      );
    }
    if (
      Array.isArray(AttendanceHoursSettings?.businessHours) &&
      ((index === 0 && AttendanceHoursSettings.businessHours.length > 1) ||
        index !== 0)
    ) {
      return (
        <div className="container-bussines-action">
          <span> Horário de Funcionamento: </span>
          <span>
            {' '}
            <img
              src={deleteHours}
              onClick={() => removeHoursAttendance(index)}
              alt=""
            />{' '}
          </span>
        </div>
      );
    }
  };

  const changeInputHours = (
    date,
    value,
    index,
    businessIndex,
    nameHours,
    nameInputHours
  ) => {
    const businessHours = [...AttendanceHoursSettings.businessHours];
    businessHours[businessIndex].schedules[index][nameHours] = date;
    businessHours[businessIndex].schedules[index][nameInputHours] = value;

    const newBusinessHours = { ...AttendanceHoursSettings, businessHours };
    setAttendanceHoursSettings(newBusinessHours);
  };

  const changeContentDays = (businessIndex, value) => {
    const businessHours = [...AttendanceHoursSettings.businessHours];
    const isCreate = businessHours[businessIndex].weekDays.find(
      (el) => el === value
    );

    if (isCreate === value) {
      const newValues = businessHours[businessIndex].weekDays.filter(
        (element) => element !== value
      );
      businessHours[businessIndex].weekDays = newValues;

      const newBusinessHours = { ...AttendanceHoursSettings, businessHours };

      setAttendanceHoursSettings(newBusinessHours);
    } else {
      const newValues = businessHours[businessIndex].weekDays.concat(value);
      businessHours[businessIndex].weekDays = newValues;

      const newBusinessHours = { ...AttendanceHoursSettings, businessHours };

      setAttendanceHoursSettings(newBusinessHours);
    }
  };

  const removeSchedules = (indexSche, businessIndex) => {
    const newBusiness = [...AttendanceHoursSettings.businessHours];
    const updateHoursAttendance = AttendanceHoursSettings.businessHours[
      businessIndex
    ].schedules.filter((_, index) => index !== indexSche);
    newBusiness[businessIndex].schedules = updateHoursAttendance;

    const newBusinessHours = {
      ...AttendanceHoursSettings,
      businessHours: newBusiness,
    };
    setAttendanceHoursSettings(newBusinessHours);
  };

  const createSchedules = (businessIndex) => {
    const newSchedules = getDefaultSchedule();
    const newBusiness = [...AttendanceHoursSettings.businessHours];
    newBusiness[businessIndex].schedules.push(newSchedules);

    const newBusinessHours = {
      ...AttendanceHoursSettings,
      businessHours: newBusiness,
    };

    setAttendanceHoursSettings(newBusinessHours);
  };

  const createHoursAttendance = () => {
    const businessHours = AttendanceHoursSettings.businessHours.concat(
      getInitialBusiness()
    );

    const newBusinessHours = { ...AttendanceHoursSettings, businessHours };

    setAttendanceHoursSettings(newBusinessHours);
  };

  const removeHoursAttendance = (removeIndex) => {
    const businessHours = AttendanceHoursSettings.businessHours.filter(
      (_, index) => index !== removeIndex
    );

    const newBusinessHours = { ...AttendanceHoursSettings, businessHours };

    setAttendanceHoursSettings(newBusinessHours);
  };

  const changeEscape = (name, value) => {
    const updatedEscape = { ...AttendanceHoursSettings.escape, [name]: value };
    const newEscape = { ...AttendanceHoursSettings, escape: updatedEscape };
    setAttendanceHoursSettings(newEscape);
  };

  const validateTimezoneEscape = () => {
    const { escape } = AttendanceHoursSettings;
    if (_.isEmpty(escape) || !escape?.to || escape?.to === '') {
      toastr.warning(
        'Aviso',
        'Por favor, configure uma opção de escape para o horário de atendimento'
      );
      return false;
    }
    const { to, message, itemId } = escape;

    if (to === 'message' && (!message || message === '')) {
      toastr.warning('Aviso', `Por favor, preencha uma mensagem para escape`);
      return false;
    }

    if (
      to === 'item' &&
      (!itemId ||
        itemId === '' ||
        (Array.isArray(itemId) && itemId.length === 0))
    ) {
      toastr.warning(
        'Aviso',
        `Por favor, escolha um item de destino para escape`
      );
      return false;
    }

    return true;
  };

  const getClientTimezoneOffset = () => {
    return new Date().getTimezoneOffset();
  };

  const correctionByTimezone = (datenocorrection, timezoneOffset) => {
    const timeNow = moment(datenocorrection)
      .utcOffset(-timezoneOffset)
      .format();

    return timeNow;
  };

  const correctSendingTimezone = (data) => {
    const { businessHours } = data;
    const offSet = getClientTimezoneOffset();
    let result;
    if (businessHours?.length !== 0) {
      businessHours.forEach((item) => {
        const { schedules } = item;
        if (schedules?.length !== 0) {
          schedules.forEach((schedule) => {
            schedule.from = correctionByTimezone(schedule.from, offSet);
            schedule.to = correctionByTimezone(schedule.to, offSet);
          });
        }
      });

      result = { ...data, businessHours };
    } else {
      result = data;
    }

    return result;
  };

  const updateBot = () => {
    if (!viewer) {
      if (bot && validateTimezoneEscape()) {
        const data = {
          ...AttendanceHoursSettings,
          ...(AttendanceHoursSettings.escape &&
            Array.isArray(AttendanceHoursSettings.escape.itemId) && {
              escape: { ...AttendanceHoursSettings.escape },
            }),
        };
        const correctData = correctSendingTimezone(data);
        updateAttendanceHoursSettings(bot._id, correctData);
      }
    }
  };

  return (
    <div className="container-all-timezone">
      <div>
        Configuração do Bot <b>Horário de Atendimento</b>
        <div className="container-hours-attendance-create">
          {AttendanceHoursSettings.businessHours.map(
            (business, businessIndex) => (
              <div
                className="container-ipt-hours-attendence"
                key={`${business._id}`}
              >
                {resultHoursAttendance(businessIndex)}
                {business.schedules.map((sche, index) => {
                  return (
                    <div className="container-hours-plus" key={`${sche._id}`}>
                      <label className="label-time-picker"> Das </label>
                      <MuiPickersUtilsProvider
                        utils={DateFnsUtils}
                        locale={ptBR}
                      >
                        <KeyboardTimePicker
                          id="time-picker-from"
                          className="time-picker-content-time-zone"
                          format="HH:mm"
                          autoOk
                          ampm={false}
                          value={sche.from}
                          inputValue={sche.inputFrom}
                          variant="inline"
                          onChange={(date, value) =>
                            changeInputHours(
                              date,
                              value,
                              index,
                              businessIndex,
                              'from',
                              'inputFrom'
                            )
                          }
                          KeyboardButtonProps={{
                            'aria-label': 'change time',
                          }}
                          InputProps={{ disableUnderline: true }}
                          invalidDateMessage="Data inválida"
                          keyboardIcon={<AccessTime />}
                        />
                        <label className="label-time-picker"> às </label>
                        <KeyboardTimePicker
                          id="time-picker-to"
                          className="time-picker-content-time-zone"
                          format="HH:mm"
                          autoOk
                          ampm={false}
                          value={sche.to}
                          inputValue={sche.inputTo}
                          variant="inline"
                          onChange={(date, value) =>
                            changeInputHours(
                              date,
                              value,
                              index,
                              businessIndex,
                              'to',
                              'inputTo'
                            )
                          }
                          KeyboardButtonProps={{
                            'aria-label': 'change time',
                          }}
                          InputProps={{ disableUnderline: true }}
                          invalidDateMessage="Data inválida"
                          keyboardIcon={<AccessTime />}
                        />
                      </MuiPickersUtilsProvider>
                      {resultDelete(business.schedules, index, businessIndex)}
                      {resultAdd(business.schedules, index, businessIndex)}
                    </div>
                  );
                })}
                <div className="container-check-days-time-zone">
                  <div>
                    <input
                      type="checkbox"
                      checked={business.weekDays.includes(1)}
                      onChange={() => changeContentDays(businessIndex, 1)}
                    />
                    <span>S</span>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      checked={business.weekDays.includes(2)}
                      onChange={() => changeContentDays(businessIndex, 2)}
                    />
                    <span>T</span>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      checked={business.weekDays.includes(3)}
                      onChange={() => changeContentDays(businessIndex, 3)}
                    />
                    <span>Q</span>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      checked={business.weekDays.includes(4)}
                      onChange={() => changeContentDays(businessIndex, 4)}
                    />
                    <span>Q</span>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      checked={business.weekDays.includes(5)}
                      onChange={() => changeContentDays(businessIndex, 5)}
                    />
                    <span>S</span>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      checked={business.weekDays.includes(6)}
                      onChange={() => changeContentDays(businessIndex, 6)}
                    />
                    <span>S</span>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      checked={business.weekDays.includes(0)}
                      onChange={() => changeContentDays(businessIndex, 0)}
                    />
                    <span>D</span>
                  </div>
                </div>
                {Array.isArray(AttendanceHoursSettings?.businessHours) &&
                  businessIndex ===
                    AttendanceHoursSettings?.businessHours?.length - 1 &&
                  AttendanceHoursSettings?.businessHours?.length < 7 && (
                    <div
                      className="create-package-addtional"
                      style={{ marginTop: 20 }}
                      onClick={createHoursAttendance}
                    >
                      <img src={addHours} alt="" />
                      <small>adicionar mais horários de funcionamento</small>
                    </div>
                  )}
              </div>
            )
          )}
        </div>
        <div className="footer-content-time-zone">
          <span>
            Selecione uma opção de escape para quando o Bot estiver fora do ar:{' '}
          </span>
          <Select
            onChange={(e) => {
              changeEscape('to', e.value);
            }}
            value={handleFindEscapeSelected()}
            options={selectValue}
            placeholder="Selecione"
          />
        </div>
        {AttendanceHoursSettings.escape.to === 'message' ? (
          <div className="footer-content-time-zone">
            <span>Digite a mensagem:</span>
            <div>
              <textarea
                type="text"
                maxLength={300}
                value={AttendanceHoursSettings.escape.message}
                onChange={(e) => {
                  changeEscape('message', e.target.value);
                }}
                placeholder="Escreva sua mensagem aqui."
                className="message-hours-attendence"
              />
            </div>
          </div>
        ) : null}
        {AttendanceHoursSettings.escape.to === 'item' ? (
          <div className="footer-content-time-zone">
            <span>Selecione o item do fluxo:</span>
            <Select
              placeholder="Selecione..."
              isSearchable
              options={itemList}
              value={handleFindItemSelected()}
              onChange={(e) => {
                changeEscape('itemId', e.value);
              }}
            />
          </div>
        ) : null}
      </div>
      <button
        onClick={updateBot}
        className={viewer ? 'btn-blue-save-inactive' : 'btn-blue-save'}
        type="button"
      >
        salvar
      </button>
    </div>
  );
};

export default SettingsAttendanceHours;
